import { createBrowserRouter, Navigate } from 'react-router-dom'
import RootLayout from 'layouts/RootLayout'
import AppShell from 'layouts/AppShell'
import AuthGuard from './AuthGuard'
import LoginPage from '../pages/login/Login'
import LogoutPage from '../pages/login/Logout'
import DashboardPage from '../pages/Dashboard/Dashboard'
import ClinetListpage from '../pages/client/clientList/ClientList'
import ClientTaskList from '../pages/client/clientTask/ClientTaskList'
import ThresholdsList from '../pages/setting/thresholds/thresholdsList/ThresholdsList'
import IntegrationList from '../pages/integration/integrationList/IntegrationList'
import RuleConfigrationList from '../pages/client/clientRule/ClientRuleConfigList'
import ClientEmailList from '../pages/client/clientEmail/ClientEmailList'
import RulesPage from '../pages/setting/rules/ruleList/RuleList'
import DocumentList from '../pages/documents/DocumentList'
import DocumentDetail from '../pages/documents/DocumentDetail'
import { ROUTES } from './Routes'
import RouteGuard from './RouteGuard'

const appRouter = () =>
  createBrowserRouter([
    {
      element: <RootLayout />,
      children: [
        {
          path: ROUTES.AUTH,
          element: <LoginPage />
        },
        {
          path: ROUTES.LOGOUT,
          element: <LogoutPage />
        },
        {
          path: '*',
          element: <Navigate to={ROUTES.AUTH} replace />
        },
        {
          element: (
            <AuthGuard>
              <AppShell />
            </AuthGuard>
          ),
          children: [
            {
              path: ROUTES.DASHBOARD,
              element: <DashboardPage />
            },
            {
              path: ROUTES.DOCUMENTS,
              element: (
                <RouteGuard requiredRoles={['admin']}>
                  <DocumentList />
                </RouteGuard>
              )
            },
            {
              path: ROUTES.DOCUMENT_DETAIL,
              element: (
                <RouteGuard requiredRoles={['admin']}>
                  <DocumentDetail />
                </RouteGuard>
              )
            },
            {
              path: ROUTES.CLIENT,
              element: (
                <RouteGuard requiredRoles={['admin']}>
                  <ClinetListpage />
                </RouteGuard>
              )
            },
            {
              path: ROUTES.CLIENT_TASK,
              element: (
                <RouteGuard requiredRoles={['admin']}>
                  <ClientTaskList />
                </RouteGuard>
              )
            },
            {
              path: ROUTES.CLIENT_INTEGRATION,
              element: (
                <RouteGuard requiredRoles={['admin']}>
                  <IntegrationList />
                </RouteGuard>
              )
            },
             {
              path: ROUTES.CLIENT_EMAIL,
              element: (
                <RouteGuard requiredRoles={['admin']}>
                  <ClientEmailList />
                </RouteGuard>
              )
            },
            {
              path: ROUTES.CLIENT_RULE_CONFIGRATION,
              element: (
                <RouteGuard requiredRoles={['admin']}>
                  <RuleConfigrationList />
                </RouteGuard>
              )
            },
            {
              path: ROUTES.CLIENT_RULES,
              element: (
                <RouteGuard requiredRoles={['admin']}>
                  <RulesPage />
                </RouteGuard>
              )
            },
            {
              path: ROUTES.CLIENT_THRESHOLDS,
              element: (
                <RouteGuard requiredRoles={['admin']}>
                  <ThresholdsList />
                </RouteGuard>
              )
            }
          ]
        }
      ]
    }
  ])

export default appRouter
